'use strict';

import angular from 'angular';
import Main from './badge.controller';

export default angular.module('aperamApp.borne.badge', [])
  .controller('BadgeController', Main)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/badge/index.js